var _title, _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgAddressOther = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "62px",
    viewBox: "0 0 42 62",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Group 3")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-854.000000, -544.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(854.000000, 544.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5208407,51.1935108 C34.0307918,38.2562358 40.75,28.1247996 40.75,21 C40.75,10.0923762 31.9076238,1.25 21,1.25 C10.0923762,1.25 1.25,10.0923762 1.25,21 C1.25,28.1378827 7.65044755,38.2635709 20.5208407,51.1935108 Z",
    id: "Oval",
    stroke: "#000000",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#000000",
    cx: 21,
    cy: 21,
    r: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    x: 19,
    y: 50,
    width: 3,
    height: 12
  }))))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAddressOther, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/address-other.7158b45a.svg";
export { ForwardRef as ReactComponent };